import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from '~/constants';
import { useStore } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { readPersistedCurrentStep } from '~/pages/VendorOnboarding/hooks/useOnboardingFlow';
import { BusinessPartyTypeEnum } from '~/store/store.model';
export const RequireVendorOnboardingComplete = (param)=>{
    let { children } = param;
    var _ref;
    var _userInfo_business;
    const history = useHistory();
    const location = useLocation();
    const { SP_ONBOARDING_PHASE_1 = false } = useFeatureFlags();
    const userInfo = useStore((state)=>state.userInfo);
    const businessType = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_business = userInfo.business()) === null || _userInfo_business === void 0 ? void 0 : _userInfo_business.type;
    const firstName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName();
    const lastName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName();
    const hasName = !!firstName && !!lastName;
    const hasBusiness = !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasBusiness());
    const workspaces = (_ref = userInfo === null || userInfo === void 0 ? void 0 : userInfo.workspaces()) !== null && _ref !== void 0 ? _ref : [];
    const activeBusinessId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessId();
    const activeWorkspace = workspaces.find((workspace)=>workspace.id() === activeBusinessId);
    const isVendor = businessType === BusinessPartyTypeEnum.Vendor;
    const isVendorPendingSignup = businessType == null && workspaces.length === 0;
    const isVendorOrPending = isVendor || isVendorPendingSignup;
    const isMidVendorOnboarding = readPersistedCurrentStep() != null;
    const isVendorSetupIncomplete = isVendor && activeWorkspace != null && !activeWorkspace.setupCompleted();
    const isActiveWorkspaceCompleted = activeWorkspace != null && activeWorkspace.isVendor() && activeWorkspace.setupCompleted();
    const isOnboardingComplete = !isMidVendorOnboarding && (isActiveWorkspaceCompleted || hasName && hasBusiness && !isVendorSetupIncomplete);
    const shouldRedirect = SP_ONBOARDING_PHASE_1 && userInfo != null && isVendorOrPending && !isOnboardingComplete && location.pathname !== routes.vendorOnboarding;
    useEffect(()=>{
        if (shouldRedirect) {
            history.replace(routes.vendorOnboarding);
        }
    }, [
        shouldRedirect,
        history
    ]);
    if (shouldRedirect) return null;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
